// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__42Jhu","message":"Alert_message__Xsapi"};